export enum SteppedLoaderImageKeys {
  DOCS = 'docs',
  CAR = 'car',
  HYUNDAI_CAR = 'hyundai_car',
  PRICE = 'price',
  SHIELD = 'shield',
}
